const TIME_OUT = 30 * 1000; // 30秒超时
const _cache = {};
function cache(name, value) {
  if (!name) throw new Error('cache -> name is null.');
  if (value) {
    //set value
    _cache[name] = value;
  } else {
    //get value
    return _cache[name] || null;
  }
}

export function createLink(urls) {
  return Promise.all(urls.map(linkUrl => new Promise((resolve, reject) => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.onload = resolve;
    link.onerror = reject;
    link.href = linkUrl;
    document.getElementsByTagName('head')[0].appendChild(link);
  })));
}

function createScript(urls) {
  return Promise.all(urls.map(fileurl => {
    if (cache(fileurl)) {
      return Promise.resolve();
    } else {
      return new Promise((resolve, reject) => {
        cache(fileurl, 'loading');
        const script = document.createElement('script');
        script.type = 'text/javascript';
        const timer = setTimeout(reject, TIME_OUT)
        if (script.readyState) {
          script.onreadystatechange = () => {
            if (script.readyState === 'loaded' || script.readyState === 'complete') {
              cache(fileurl, 'loaded');
              script.onreadystatechange = null;
              timer && clearTimeout(timer);
              resolve()
            }
          };
        } else {
          script.onload = () => {
            cache(fileurl, 'loaded');
            timer && clearTimeout(timer);
            resolve();
          };
          script.onerror = () => {
            timer && clearTimeout(timer);
            reject()
          };
        }
        script.src = fileurl;
        document.getElementsByTagName('head')[0].appendChild(script);
      })
    }
  }));
}

function load(url, type) {
  const urls = url
    ? Array.isArray(url)
      ? url
      : url.trim().split(/\s*,\s*/) 
    : [];
  if (urls.length === 0) {
    return Promise.resolve();
  }
  return type === 'js' ? createScript(urls) : createLink(urls);
}


export function loadJs(namelist) {
  return load(namelist, 'js');
}
export function loadCss(namelist) {
  return load(namelist, 'css');
}

export function loadImage(imageUrl) {
  const img = new Image(); 
  return new Promise((resolve, reject) => {
    img.src = imageUrl;  
    if (img.complete) { //如果图片已经存在于浏览器缓存，直接调用回调函数
      resolve(img)
    } else {
      img.onload = () => resolve(img)
      img.onerror = reject
    }
  });
}
